import { extractError } from '../../components/Api';

export const settingTypeLookup = {
	// Pins
	queryPin: 'query-pins',
	scopePin: 'scope-pins',
	dashboardPin: 'dashboard-pins',
	reportPin: 'report-template-pins',

	// Options
	analysisSettings: 'analysis-settings',
	inboxPreview: 'inbox-preview'
};

/**
 * PATCH - Update a user's settings
 * @param {object} ApiHandler - which API to call
 * @param {number} workspace_id - the current workspace
 * @param {string} setting_type - the type of setting to be updated
 * @param {*} value - the id of the setting to be updated
 * @param {*} payload - the values to be updated
 * @returns success, or error message
 */
export const updateUserSettings = ({ getClientApi }, workspace_id, setting_type, payload) => {
	return getClientApi().then((api) =>
		api
			.patch(`workspace/v1/${workspace_id}/settings/${setting_type}`, payload)
			.then(({ data }) => data)
			.catch((e) => ({ message: extractError(e) }))
	);
};
